<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item v-show="false" label="活动ID">
                  <el-input  v-model="queryForm.activityId"></el-input>
              </el-form-item>
              <el-form-item label="商品ID">
                  <el-input  v-model="queryForm.productId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopFloorActivityProductList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopFloorActivityProduct"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopFloorActivityProduct(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopFloorActivityProduct(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopFloorActivityProductList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopFloorActivityProductList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopFloorActivityProductList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="activityId"
        label="活动ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="productId"
        label="商品ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopFloorActivityProduct(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopFloorActivityProduct(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopFloorActivityProduct(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopFloorActivityProductStates[shopFloorActivityProductState]"
      :visible.sync="showDialog"
      width="400px"
      :modal="false"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopFloorActivityProduct"
          ref="shopFloorActivityProductForm"
          :rules="rules"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="活动ID"
            prop="activityId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloorActivityProduct.activityId"-->
<!--              disabled-->
<!--            ></el-input>-->
              <el-select
                  style="width: 283px"
                  v-model="shopFloorActivityProduct.activityId"
                  placeholder="请选择所属楼层"
                  disabled
                  clearable
                  size="small"
              >
                  <el-option v-for="(item,index) in ActiveIdList " :label="item.activityName" :value="item.id" :key="index"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="商品ID"
            prop="productId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloorActivityProduct.productId"-->
<!--              :disabled="shopFloorActivityProductState == 'check'"-->
<!--            ></el-input>-->
              <div style="display: flex;">
                  <GridSelectLi
                      ref="add1"
                      style="width: 220px;"
                      title="选择商品"
                      labelName="productName"
                      labelValue="id"
                      :disabled="shopFloorActivityProductState == 'check'"
                      :did="did"
                      :value="shopFloorActivityProduct.productId"
                      :limit="99"
                      size="small"
                      placeholder="请选择商品"
                      @getValue="getValuebrandId"
                      :columns="PRODUCT_code"
                      :searchs="PRODUCT_search"
                      dataListUrl="/shop/product/findList"
                      entityBeanName="shopProduct"
                      queryEntityUrl="/shop/product/get"
                  >
                  </GridSelectLi>
                  <el-button style="height: 30px;margin: 0 4px;width: 55px" type="primary" @click="add1">添加</el-button>
              </div>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopFloorActivityProductState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { PRODUCT, PRODUCT_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopFloorActivityProductList();
                    this.getShopFloorActivityProductList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopFloorActivityProductList();
                    this.getShopFloorActivityProductList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     activityId: '', //活动ID
                     productId: '', //商品ID
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopFloorActivityProductState: 'add',
                shopFloorActivityProductStates: {
                    add: '新建shop_floor_activity_product',
                    check: '查看shop_floor_activity_product',
                    edit: '修改shop_floor_activity_product'
                },

                multipleSelection: [],
                shopFloorActivityProductList: [],
                shopFloorActivityProduct: {
                    id: '', //id
                    activityId: '', //活动ID
                    productId: '', //商品ID
                },
                btnLoading: false,
                ActiveIdList: [],
                rules: {
                    id: [{ required: true, message: 'id不能为空', trigger: 'blur' }],
                    activityId: [{ required: true, message: '活动ID不能为空', trigger: 'blur' }],
                    productId: [{ required: true, message: '商品ID不能为空', trigger: 'blur' }],
                },
                PRODUCT_code: PRODUCT,
                PRODUCT_search: PRODUCT_SEARCH,
                did:'',
            };
        },
        created() {
            // this.getShopFloorActivityProductList();
        },
        methods: {
            updateId(id) {
                this.queryForm.activityId = id;
                this.getShopFloorActivityProductList();
                this.getActiveIdList()
            },
            getValuebrandId(val){
                this.shopFloorActivityProduct.productId = val
            },
            add1(){
                this.$refs.add1.showSelectDialog();
                console.log(this.$refs.add1)
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopFloorActivityProductList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopFloorActivityProductList = [];
            },
            resetDialog() {
                this.shopFloorActivityProductState = 'add';
                this.showDialog = false;
                this.shopFloorActivityProduct = {
                      activityId: this.queryForm.activityId, //活动ID
                      productId: '', //商品ID
                };
                this.getShopFloorActivityProductList();
            },
            getActiveIdList(){
                get(`/shop/flooractivity/findAll`,{ id: this.currentShopFloorActivityId }).then((res) =>{
                    if(res.success){
                        this.ActiveIdList = res.list
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            closeDialog() {
                this.showDialog = false
                this.shopFloorActivityProduct = {
                      id: '', //id
                      activityId: '', //活动ID
                      productId: '', //商品ID
                };
            },
            submitForm() {
                if (this.shopFloorActivityProductState == 'add') {
                    this.$refs.shopFloorActivityProductForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/flooractivityproduct/add`,{ ...this.shopFloorActivityProduct }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopFloorActivityProductList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopFloorActivityProductState == 'edit') {
                    this.$refs.shopFloorActivityProductForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopFloorActivityProduct.updateTime
                            delete this.shopFloorActivityProduct.product
                            post(`/shop/flooractivityproduct/edit`,{ ...this.shopFloorActivityProduct }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopFloorActivityProductList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopFloorActivityProduct() {
                this.showDialog = true;
                this.shopFloorActivityProductState = 'add';
                this.shopFloorActivityProduct.activityId = this.queryForm.activityId
            },
            checkShopFloorActivityProduct(shopFloorActivityProductId) {
                console.log(shopFloorActivityProductId);
                this.currentShopFloorActivityProductId = shopFloorActivityProductId;

                this.getShopFloorActivityProductById();
                this.showDialog = true;
                this.shopFloorActivityProductState = 'check';
            },
            editShopFloorActivityProduct(shopFloorActivityProductId) {
                console.log('shopFloorActivityProduct', shopFloorActivityProductId);
                if (shopFloorActivityProductId) {
                    this.currentShopFloorActivityProductId = shopFloorActivityProductId;
                    this.getShopFloorActivityProductById();
                } else {
                    this.shopFloorActivityProduct = { ...this.shopFloorActivityProduct, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopFloorActivityProductState = 'edit';
            },
            deleteShopFloorActivityProduct(shopFloorActivityProductId) {
                let ids = '';
                if (shopFloorActivityProductId) {
                    ids = shopFloorActivityProductId;
                } else {
                    ids = this.multipleSelection.map((shopFloorActivityProduct) => shopFloorActivityProduct.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/flooractivityproduct/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopFloorActivityProductList();
                                this.getShopFloorActivityProductList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopFloorActivityProductList() {
                this.resetShopFloorActivityProductList();
                this.getShopFloorActivityProductList();
            },
            getShopFloorActivityProductList(query = {}) {
                this.loading = true;
                get(`/shop/flooractivityproduct/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopFloorActivityProductList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopFloorActivityProductById() {
                get(`/shop/flooractivityproduct/get`,{ id: this.currentShopFloorActivityProductId }).then((res) =>{
                    if(res.success){
                      this.shopFloorActivityProduct = { ...this.shopFloorActivityProduct, ...res.shopFloorActivityProduct };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopFloorActivityProductList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/flooractivityproduct/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/flooractivityproduct/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/flooractivityproduct/importData`,formData);
              this.refreshShopFloorActivityProductList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopFloorActivityProductList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopFloorActivityProductList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>